<!-- components/EditForm.vue -->
<template>
    <div class="edit-form">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
            <el-form-item label="用户名" prop="userName" v-show="typePage == 'Password'">
                <el-input v-model="form.userName"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" v-show="!modelLogin">
                <el-input v-model="form.email"></el-input>
                <el-button type="primary" @click="emailYzmSent" id="buttonEmailYzmSent"
                    :disabled="emailCountdown > 0">{{ emailCountdown > 0 ? `${emailCountdown}s 后重发` : '发送验证码'
                    }}</el-button>
            </el-form-item>
            <el-form-item label="邮箱验证码" prop="emailyzm" v-show="!modelLogin">
                <el-input v-model="form.emailyzm"></el-input>
            </el-form-item>
            <el-form-item label="新的密码" prop="passWord" v-show="typePage == 'Password'">
                <el-input v-model="form.passWord" show-password></el-input>
            </el-form-item>
            <el-form-item label="再次输入密码" prop="passWordAgain" v-show="typePage == 'Password'">
                <el-input v-model="form.passWordAgain" show-password></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="yzm">
                <el-input v-model="form.yzm" class="yzm" placeholder="请输入图形验证码"></el-input>
                <img :src="captchaImage" alt="验证码" @click="refreshCaptcha" class="captcha-image" />
            </el-form-item>
            <div class="button-div">
                <el-button type="primary" @click="verifyData" v-show="!modelLogin">提交</el-button>
                <el-button @click="close">关闭</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import request from '@/utils/request' // 就写这一行

export default {
    name: 'ForgetPageST',
    props: ['typePage'],
    data() {
        return {
            form: {
                "userName": "",
                "passWord": "",
                "passWordAgain": "",
                "yzm": "",
                "emailyzm": "",
                "email": ""
            }, // 复制数据避免直接修改 props
            rules: {
                userName: [
                    { required: true, message: '请输入您的用户名', trigger: 'blur' },
                    { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
                ],
                passWord: [
                    { required: true, message: '请输入您的新密码', trigger: 'blur' }
                ],
                passWordAgain: [
                    { required: true, message: '请再次输入您的密码', trigger: 'blur' }
                ],
                yzm: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入您的邮箱', trigger: 'blur' }
                ],
                emailyzm: [
                    { required: true, message: '请输入系统发送给您的邮箱验证码', trigger: 'blur' }
                ]
            },
            captchaImage: "",
            captchaImageAn: "",
            isEmailSending: false,
            emailCountdown: 0, // 倒计时秒数（0 表示未开始或已结束）
            countdownInterval: null
        }
    },
    methods: {
        verifyData() {
            // 登录账号
            // if (this.form.yzm.trim().toLowerCase() !== this.captchaImageAn.toLowerCase()) {
            //     this.$messageX.xiaoxiti("e", "图形验证码错误");
            //     return;
            // }
            const { userName, passWord, passWordAgain, email, emailyzm } = this.form; // 假设表单字段为 account 和 password

            if (this.typePage == "Account") {
                if (!email) {
                    this.$messageX.xiaoxiti("w", "请输入邮箱");
                    return;
                }
            } else {
                if (!userName || !passWord || !passWordAgain || !email || !emailyzm) {
                    this.$messageX.xiaoxiti("w", "请输入账号、密码、邮箱、邮箱验证码");
                    return;
                }
            }

            if (passWord !== passWordAgain) {
                this.$messageX.xiaoxiti("w", "两次密码输入不相同！");
                return;
            }
            this.registrationsaveData();
        },
        async registrationsaveData() {
            try {
                // 自动带 Token，自动处理错误
                const res = await request.post('/Forget', {
                    MailBox: this.form.email,
                    emailYZM: this.form.emailyzm,
                    forgetType: this.typePage,
                    UserName: this.form.userName,
                    PassWord: this.form.passWord,
                    PassWordX: this.form.passWordAgain,
                    PictureVerify: this.form.yzm,
                    veriftyID: this.captchaImageAn
                })

                // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
                this.$messageX.xiaoxiti("c", res.message);
                this.$emit('save', {
                    success: true,
                    message: res.message,
                    response: res.response
                });
                this.close();

            } catch (err) {
                // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                    this.$emit('save', {
                        success: false,
                        message: err.response.data.message
                    });
                } else {
                    this.$messageX.xiaoxiti("e", err.message);
                    this.$emit('save', {
                        success: false,
                        message: err.message
                    });
                }
            }

        },
        close() {
            this.$emit('close');
        },
        async refreshCaptcha() {
            try {
                // 自动带 Token，自动处理错误
                const res = await request.get('/HuoQuTuPianYanZhenMa', {
                })

                // 如果代码能走到这里，说明 HTTP 200 且 后端 success=true
                this.$messageX.xiaoxiti("c", "图片验证码刷新成功！");
                this.captchaImage = res.captchaImageSrc;
                this.captchaImageAn = res.veriftyID;

            } catch (err) {
                // 如果出错 (HTTP 401/500 或 后端 success=false)，会进这里
                console.log('失败:', err)
                if (err.response.data.message) {
                    this.$messageX.xiaoxiti("e", err.response.data.message);
                } else {
                    this.initData();
                    this.$messageX.xiaoxiti("e", err.message);
                }
            }
        },
        async emailYzmSent() {
            // 校验邮箱格式（可选增强）
            if (this.isEmailSending) return;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!this.form.email || !emailRegex.test(this.form.email)) {
                this.$messageX.xiaoxiti("w", "请输入有效的邮箱地址");
                return;
            }
            // 如果正在倒计时，直接返回
            if (this.emailCountdown > 0) return;

            this.isEmailSending = true;
            try {
                const email = encodeURIComponent(this.form.email);
                const res = await fetch(`//www.aboluo.site/api/HuoQuEmailYanZhenMa/${email}?t=${Date.now()}`);
                const data = await res.json();
                if (data.success) {
                    this.$messageX.xiaoxiti("i", `邮件已发送至【${this.form.email}】`);
                    // 可加倒计时禁用按钮（如 60 秒）
                    this.startEmailCountdown(120);
                } else {
                    this.$messageX.xiaoxiti("e", data.message);
                }
            } finally {
                setTimeout(() => {
                    this.isEmailSending = false;
                }, 60000); // 60秒内禁止再次发送
            }
        },
        startEmailCountdown(seconds) {
            // 清除可能存在的旧定时器
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }

            this.emailCountdown = seconds;

            this.countdownInterval = setInterval(() => {
                this.emailCountdown--;
                if (this.emailCountdown <= 0) {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                }
            }, 1000);
        },
        initData() {
            if (this.typePage == "Account") {
                this.rules.passWord.required = false;
                this.rules.passWordAgain.required = false;
                this.rules.userName.required = false;
            }
        }
    },
    mounted() {
        var type_str = ["Password", "Account"];
        if (!type_str.includes(this.typePage)) {
            this.$messageX.xiaoxiti("e", "系统运行出现错误！");
            console.log("控件传入值【typePage】错误！" + this.typePage);
            this.close();
        } else {
            this.refreshCaptcha();
            this.initData();
        }

    },
    beforeUnmount() {

    },
}
</script>

<style scoped>
.edit-form input {
    display: block;
    margin-bottom: 10px;
    padding: 6px;
}

.button-div {
    margin-left: 80px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 18px;
}

.yzm {
    width: 56%;
    height: 48px;
}

.captcha-image {
    height: 46px;
    width: 120px;
    border: 2px solid #ddd;
    border-left: none;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
}
</style>